export const PLAYER_MODE = {
  NORMAL: 0,
  SLICE_VIEW: 1,
  SLICE_EDIT: 2
};

export const PLAYER_POSITION_STORAGE_KEY = '@@kmedia_player_position';
